import {
	GET_LIST_GLOBAL_PROJECT,
	GET_LIST_MY_PROJECT,
	GET_PROJECT,
	GET_PROJECT_HISTORY,
	CREATE_PROJECT,
	UPDATE_PROJECT,
	DELETE_PROJECT,
	CLEAR_PROJECT,
	CLEAR_LIST_GLOBAL_PROJECT,
	CLEAR_LIST_MY_PROJECT,
	QUERY_GLOBAL_PROJECT,
	QUERY_MY_PROJECT,
	GET_OTHER_PROJECT,
	CLEAR_OTHER_PROJECT,
	PUT_REPORTFILE,
	GET_REPORTFILE,
	DELETE_REPORTFILE,
	ADD_AMOUNT_COMMENT,
	REDUCE_AMOUNT_COMMENT,
	LIKE_PROJECT,
	UNLIKE_PROJECT,
	CLEAR_REPORTFILE,
	ADD_TO_MY_PROJECT,
	GET_PROJECT_NOTI,
	GET_RECOMMEND_PROJECT
} from "../ActionTypes"
import { checkDupArray } from "../FunctionAction/function.project"

const comparelast = (a, b) => {
	if (a.last_modified > b.last_modified) return -1
	if (b.last_modified > a.last_modified) return 1
	return 0
}
const initialState = {
	globalprojects: [],
	myprojects: [],
	otherproject: [],
	allproject: [],
	recommendproject: [],
	project: {},
	LastEvaluatedKeymy: {},
	LastEvaluatedKeyglobal: {},
	LastEvaluatedKeyother: {},
	LastEvaluatedKeyfollowing: {},
	LastEvaluatedKeyallproject: {},
	reportfiles: [],
	loading: true,
	loadingproject: true,
	loadingallproject: true,
	finish: false,
	finisdelete: false,
	finishreport: false
}

export default (state = initialState, { type, payload }) => {
	const { globalprojects, myprojects, otherproject } = state
	switch (type) {
		case GET_LIST_GLOBAL_PROJECT + "_FULFILLED":
			return {
				...state,
				globalprojects: checkDupArray(
					globalprojects,
					payload.data.getListGlobalProject.data
				),
				LastEvaluatedKeyglobal: payload.data.getListGlobalProject.next_token,
				loading: false
			}
		case GET_LIST_GLOBAL_PROJECT + "_PENDING":
			return { ...state, loading: true }
		case GET_LIST_GLOBAL_PROJECT + "_REJECTED":
			return { ...state, loading: false }
		case GET_LIST_MY_PROJECT + "_FULFILLED":
			return {
				...state,
				myprojects: checkDupArray(
					myprojects,
					payload.data.getListMyProject.data
				),
				LastEvaluatedKeymy: payload.data.getListMyProject.next_token,
				loading: false
			}
		case GET_LIST_MY_PROJECT + "_PENDING":
			return { ...state, loading: true }
		case GET_LIST_MY_PROJECT + "_REJECTED":
			return { ...state, loading: false }
		case GET_OTHER_PROJECT + "_FULFILLED":
			return {
				...state,
				otherproject: checkDupArray(
					otherproject,
					payload.data.getOtherProject.data
				),
				LastEvaluatedKeyother: payload.data.getOtherProject.next_token,
				loading: false
			}
		case GET_OTHER_PROJECT + "_PENDING":
			return { ...state, loading: true }
		case GET_OTHER_PROJECT + "_REJECTED":
			return { ...state, loading: false }
		case GET_PROJECT + "_FULFILLED":
			return {
				...state,
				project: payload.data.getProject.data[0],
				loadingproject: false
			}
		case GET_PROJECT + "_PENDING":
			return { ...state, loadingproject: true }
		case GET_PROJECT + "_REJECTED":
			return { ...state, loadingproject: false }
		case GET_PROJECT_NOTI + "_FULFILLED":
			return {
				...state,
				loadingproject: false
			}
		case GET_PROJECT_NOTI + "_PENDING":
			return { ...state, loadingproject: true }
		case GET_PROJECT_NOTI + "_REJECTED":
			return { ...state, loadingproject: false }

		case GET_PROJECT_HISTORY + "_FULFILLED":
			return { ...state, loadingproject: false }
		case GET_PROJECT_HISTORY + "_PENDING":
			return { ...state, loadingproject: true }
		case GET_PROJECT_HISTORY + "_REJECTED":
			return { ...state, loadingproject: false }
		case CREATE_PROJECT + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case CREATE_PROJECT + "_PENDING":
			return { ...state, finish: true }
		case CREATE_PROJECT + "_REJECTED":
			return { ...state, finish: false }
		case UPDATE_PROJECT + "_FULFILLED":
			return {
				...state,
				finish: false
			}
		case UPDATE_PROJECT + "_PENDING":
			return { ...state, finish: true }
		case UPDATE_PROJECT + "_REJECTED":
			return { ...state, finish: false }
		case DELETE_PROJECT + "_FULFILLED":
			return {
				...state,
				finisdelete: false
			}
		case DELETE_PROJECT + "_PENDING":
			return { ...state, finisdelete: true }
		case DELETE_PROJECT + "_REJECTED":
			return { ...state, finisdelete: false }
		case QUERY_GLOBAL_PROJECT + "_FULFILLED":
			return {
				...state,
				globalprojects: checkDupArray(
					globalprojects,
					payload.data.queryProject.data
				).sort(comparelast),
				LastEvaluatedKeyglobal: payload.data.queryProject.next_token,
				loading: false
			}
		case QUERY_GLOBAL_PROJECT + "_PENDING":
			return { ...state, loading: true }
		case QUERY_GLOBAL_PROJECT + "_REJECTED":
			return { ...state, loading: false }
		case QUERY_MY_PROJECT + "_FULFILLED":
			return {
				...state,
				myprojects: checkDupArray(
					myprojects,
					payload.data.queryProject.data
				).sort(comparelast),
				LastEvaluatedKeymy: payload.data.queryProject.next_token,
				loading: false
			}
		case QUERY_MY_PROJECT + "_PENDING":
			return { ...state, loading: true }
		case QUERY_MY_PROJECT + "_REJECTED":
			return { ...state, loading: false }
		case PUT_REPORTFILE + "_FULFILLED":
			return {
				...state,
				finishreport: false
			}
		case PUT_REPORTFILE + "_PENDING":
			return { ...state, finishreport: true }
		case PUT_REPORTFILE + "_REJECTED":
			return { ...state, finishreport: false }
		case GET_REPORTFILE + "_FULFILLED":
			return {
				...state,
				reportfiles: payload.data.getReport,
				finishreport: false
			}
		case GET_REPORTFILE + "_PENDING":
			return { ...state, finishreport: true }
		case GET_REPORTFILE + "_REJECTED":
			return { ...state, reportfiles: [], finishreport: false }
		case DELETE_REPORTFILE + "_FULFILLED":
			return {
				...state,
				reportfiles: [],
				finishreport: false
			}
		case DELETE_REPORTFILE + "_PENDING":
			return { ...state, finishreport: true }
		case DELETE_REPORTFILE + "_REJECTED":
			return { ...state, finishreport: false }
		case ADD_AMOUNT_COMMENT:
			for (let i = 0; i < globalprojects.length; i++) {
				if (globalprojects[i].project_id === payload) {
					globalprojects[i].amount_comment =
						globalprojects[i].amount_comment + 1
				}
			}
			return { ...state, globalprojects, finish: false }
		case REDUCE_AMOUNT_COMMENT:
			for (let i = 0; i < globalprojects.length; i++) {
				if (globalprojects[i].project_id === payload) {
					globalprojects[i].amount_comment =
						globalprojects[i].amount_comment - 1
				}
			}
			return { ...state, globalprojects, finish: false }
		case CLEAR_PROJECT:
			return { ...state, project: {} }
		case CLEAR_LIST_GLOBAL_PROJECT:
			return {
				...state,
				globalprojects: []
			}
		case CLEAR_LIST_MY_PROJECT:
			return {
				...state,
				myprojects: []
			}
		case CLEAR_OTHER_PROJECT:
			return {
				...state,
				otherproject: []
			}
		case CLEAR_REPORTFILE:
			return {
				...state,
				reportfiles: []
			}
		case LIKE_PROJECT + "_FULFILLED":
			for (let i = 0; i < globalprojects.length; i++) {
				if (
					globalprojects[i].project_id ===
					payload.data.addLikeProject.project_id
				) {
					globalprojects[i].project_likes =
						payload.data.addLikeProject.project_likes
				}
			}
			return { ...state, globalprojects }
		case LIKE_PROJECT + "_PENDING":
			return { ...state }
		case LIKE_PROJECT + "_REJECTED":
			return { ...state }
		case UNLIKE_PROJECT + "_FULFILLED":
			for (let i = 0; i < globalprojects.length; i++) {
				if (
					globalprojects[i].project_id === payload.data.unLikeProject.project_id
				) {
					globalprojects[i].project_likes =
						payload.data.unLikeProject.project_likes
				}
			}
			return { ...state, globalprojects }
		case UNLIKE_PROJECT + "_PENDING":
			return { ...state }
		case UNLIKE_PROJECT + "_REJECTED":
			return { ...state }
		case ADD_TO_MY_PROJECT + "_FULFILLED":
			return { ...state }
		case ADD_TO_MY_PROJECT + "_PENDING":
			return { ...state }
		case ADD_TO_MY_PROJECT + "_REJECTED":
			return { ...state }
		case GET_RECOMMEND_PROJECT + "_FULFILLED":
			return {
				...state,
				recommendproject: payload.data.getRecommendProject.data,
				loading: false
			}
		case GET_RECOMMEND_PROJECT + "_PENDING":
			return { ...state, loading: true }
		case GET_RECOMMEND_PROJECT + "_REJECTED":
			return { ...state, loading: false }
		default:
			return state
	}
}
